import { useQueries, useQueryClient } from '@tanstack/react-query';

export function createGlobalStates(queryKey, queryFunction, defaultTime = 60_000) {
  return function (queryArray, condition = true, id = null) {
    const queryClient = useQueryClient();

    const queries = queryArray
      ? queryArray.map((current) => ({
          queryKey: [queryKey, id ? current[id] : current],
          queryFn: () => queryFunction(id ? current[id] : current),
          refetchOnMount: false,
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
          enabled: condition,
          staleTime: defaultTime,
          cacheTime: defaultTime,
        }))
      : [];

    const results = useQueries({
      queries,
    });

    const data = results.map((result) => result.data);
    const isLoadingdata =
      condition && results.some((result) => result.isLoading);
    const isFetching =
      condition && results.some((result) => result.isFetching);
    const isError = results.some((result) => result.isError);
    const errors = results.filter((result) => result.error).map((result) => result.error);

    function setData(newData, index) {
      if (index !== undefined && queries[index]) {
        queryClient.setQueryData(queries[index].queryKey, newData);
      }
    }

    function resetData() {
      // One request per entry; see resetData in ./index.js.
      queries.forEach((query) => {
        queryClient.invalidateQueries({
          queryKey: query.queryKey,
          refetchType: 'all',
        });
      });
    }

    // queryKeys: the prefixes resetData refreshes.
    const queryKeys = queries.map((query) => query.queryKey);

    return {
      data,
      isLoadingdata,
      isFetching,
      isError,
      errors,
      setData,
      resetData,
      queryKeys,
    };
  };
}
